// Keeps bulk orders above 999 possible while still avoiding accidental runaway values.
export const CART_ITEM_QUANTITY_MAX = 999999
